var _style, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrownRice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AA1917;}\n\t.st1{fill:#EDBE7E;}\n\t.st2{fill:#FDD9AD;}\n\t.st3{fill:#E7A277;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 103.68,
    cy: 144.71,
    rx: 31.44,
    ry: 7.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 103.68,
    cy: 141.32,
    rx: 18.86,
    ry: 1.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M133.76,142.66c-3.91,2.91-15.9,5.03-30.09,5.03s-26.18-2.12-30.09-5.03c-0.87,0.65-1.35,1.34-1.35,2.06 c0,3.92,14.08,7.09,31.44,7.09s31.44-3.17,31.44-7.09C135.11,144,134.64,143.31,133.76,142.66z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9015 -0.4327 0.4327 0.9015 -36.8771 70.2852)",
    className: "st1",
    cx: 136,
    cy: 116.18,
    rx: 31.44,
    ry: 7.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9015 -0.4327 0.4327 0.9015 -35.699 69.3496)",
    className: "st2",
    cx: 134.54,
    cy: 113.12,
    rx: 18.86,
    ry: 1.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M162.24,101.3c-2.27,4.32-12.16,11.42-24.95,17.56c-12.79,6.14-24.52,9.42-29.3,8.48 c-0.51,0.97-0.64,1.79-0.33,2.44c1.69,3.53,15.76,0.3,31.41-7.21c15.65-7.51,26.97-16.46,25.28-19.99 C164.04,101.93,163.31,101.51,162.24,101.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4618 -0.887 0.887 0.4618 -52.1064 123.4231)",
    className: "st1",
    cx: 75.66,
    cy: 104.65,
    rx: 7.09,
    ry: 31.44
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4618 -0.887 0.887 0.4618 -48.5966 123.1936)",
    className: "st2",
    cx: 77.22,
    cy: 101.64,
    rx: 1.85,
    ry: 18.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.29,116.72c-4.81,0.78-16.43-2.88-29.01-9.43c-12.59-6.55-22.24-13.97-24.36-18.36 c-1.08,0.17-1.82,0.57-2.15,1.2c-1.81,3.47,9.21,12.79,24.61,20.81s29.35,11.7,31.16,8.23 C103.87,118.53,103.77,117.7,103.29,116.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9946 -0.1034 0.1034 0.9946 -8.5418 14.0372)",
    className: "st1",
    cx: 131.13,
    cy: 89.41,
    rx: 31.44,
    ry: 7.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9946 -0.1034 0.1034 0.9946 -8.195 13.9829)",
    className: "st2",
    cx: 130.78,
    cy: 86.04,
    rx: 18.86,
    ry: 1.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M160.85,84.26c-3.59,3.3-15.29,6.65-29.41,8.12c-14.11,1.47-26.26,0.6-30.45-1.89 c-0.8,0.74-1.2,1.47-1.13,2.19c0.4,3.89,14.73,5.6,32,3.8s30.94-6.41,30.54-10.3C162.33,85.45,161.78,84.81,160.85,84.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9965 -0.0838 0.0838 0.9965 -5.6227 8.2066)",
    className: "st1",
    cx: 94.94,
    cy: 71.08,
    rx: 31.44,
    ry: 7.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9965 -0.0838 0.0838 0.9965 -5.3405 8.1709)",
    className: "st2",
    cx: 94.65,
    cy: 67.7,
    rx: 18.86,
    ry: 1.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124.75,66.5c-3.65,3.23-15.42,6.35-29.56,7.54s-26.26,0.08-30.4-2.49c-0.82,0.72-1.23,1.45-1.17,2.16 c0.33,3.9,14.62,5.88,31.92,4.43c17.3-1.46,31.06-5.8,30.73-9.7C126.2,67.73,125.67,67.08,124.75,66.5z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.75,119.26c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrownRice);
export default __webpack_public_path__ + "static/media/Brown_rice.2089fff625213ade87c2f5a512fe3c39.svg";
export { ForwardRef as ReactComponent };